module.exports = __webpack_public_path__ + "media/images/wallstreetjournal-296d8ef9a0f5c3535314c4789fa922a33755dd24ef2ee580d76089d57ba1ea8a.jpg";